module.exports = __webpack_public_path__ + "static/media/Cart Popup.10c11947.svg";